import '../../assets/components/ProductCardMarketingText/productCardMarketingText.css';const n = "_container_1glkq_1", t = "_unsetPadding_1glkq_6", e = {
  container: n,
  unsetPadding: t
};
export {
  n as container,
  e as default,
  t as unsetPadding
};
